<div class="indicators mat-typography mat-body">
  @for (indicator of plan?.summaryView?.icons; track indicator) {
    @if (indicator.value) {
      <div class="padding-offset-for-icons">
        <div [matTooltip]="config[indicator.key].tooltip">
          <img [alt]="config[indicator.key].imgAlt" [src]="angularHostUrl + config[indicator.key].imgFile">
        </div>
      </div>
    }
  }
</div>
